/* eslint-disable no-case-declarations */
import * as types from './types';

const emptyProjects = {
  hasMore: false,
  currentPage: 0,
  limit: 0,
  start: 0,
  total: 0,
  projects: [],
};

const initialState = {
  projectsLimit: {
    limit: 0,
    isExceeded: false,
    isOwner: false,
    activeWeddingCount: 0,
  },
  currentProject: {},
  activeProjects: emptyProjects,
  archivedProjects: emptyProjects,
  searchedProjects: emptyProjects,
  isProjectsLoaded: false,
};

export default (state = initialState, action) => {
  const { projectStatus } = action;
  const { currentPage, limit, pages, start, total, items } = action.payload?.loginWeddings || emptyProjects;
  const { archiveWedding } = action.payload || {};
  const { deleteWedding } = action.payload || {};
  const { projectChanges } = action.payload || {};
  let newList = [];
  const hasMore = currentPage < pages;
  switch (action.type) {
    case types.SET_PROJECTS_LOADED:
      return { ...state, isProjectsLoaded: true };
    case types.GET_PROJECT_LIMITS:
      return { ...state };

    case types.GET_PROJECT_LIMITS_SUCCESS:
      return {
        ...state,
        projectsLimit: action.payload,
      };

    case types.GET_PROJECTS:
      return { ...state };

    case types.GET_PROJECTS_SUCCESS:
      if (projectStatus === 'active') {
        return {
          ...state,
          activeProjects: {
            hasMore,
            currentPage,
            limit,
            start,
            total,
            projects: items,
          },
        };
      }
      if (projectStatus === 'archived') {
        return {
          ...state,
          archivedProjects: {
            hasMore,
            currentPage,
            limit,
            start,
            total,
            projects: items,
          },
        };
      }
      if (projectStatus === 'searched') {
        return {
          ...state,
          searchedProjects: {
            hasMore,
            currentPage,
            limit,
            start,
            total,
            projects: items,
          },
        };
      }
      return { ...state };

    case types.GET_MORE_PROJECTS_SUCCESS:
      if (projectStatus === 'active') {
        const prevProjects = state.activeProjects.projects;
        return {
          ...state,
          activeProjects: {
            hasMore,
            currentPage,
            limit,
            start,
            total,
            projects: [...prevProjects, ...items],
          },
        };
      }
      if (projectStatus === 'archived') {
        const prevProjects = state.archivedProjects.projects;
        return {
          ...state,
          archivedProjects: {
            hasMore,
            currentPage,
            limit,
            start,
            total,
            projects: [...prevProjects, ...items],
          },
        };
      }
      if (projectStatus === 'searched') {
        const prevProjects = state.searchedProjects.projects;
        return {
          ...state,
          archivedProjects: {
            hasMore,
            currentPage,
            limit,
            start,
            total,
            projects: [...prevProjects, ...items],
          },
        };
      }
      return { ...state };

    case types.ARCHIVE_PROJECT_SUCCESS:
      const { id: archivedId, isArchived } = archiveWedding.wedding || {};
      /**
       * #TODO: Currently just shoving the found item at end of the other list so that tabs don't
       * get hidden accidentally if the other list it empty. This should be handled better for tabs
       * that have many items because there is sorting and filtering that needs to be respected
       * when adding an item to the opposite list.
       */
      if (isArchived) {
        newList = state.activeProjects.projects.filter(p => p.weddingId !== archivedId);
        const changedItem = state.activeProjects.projects.find(p => p.weddingId === archivedId);
        return {
          ...state,
          activeProjects: {
            ...state.activeProjects,
            projects: newList,
          },
          archivedProjects: {
            ...state.archivedProjects,
            // Reset current page to 0 to re-fetch after changing tabs.
            currentPage: 0,
            projects: [...state.archivedProjects.projects, changedItem],
          },
        };
      }
      newList = state.archivedProjects.projects.filter(p => p.weddingId !== archivedId);
      const changedItem = state.archivedProjects.projects.find(p => p.weddingId === archivedId);
      return {
        ...state,
        archivedProjects: {
          ...state.archivedProjects,
          projects: newList,
        },
        activeProjects: {
          ...state.activeProjects,
          // Reset current page to 0 to re-fetch after changing tabs.
          currentPage: 0,
          projects: [...state.activeProjects.projects, changedItem],
        },
      };

    case types.DELETE_PROJECT_SUCCESS:
      const { id: deletedId } = deleteWedding.wedding;
      newList = state.archivedProjects.projects.filter(p => p.weddingId !== deletedId);
      return {
        ...state,
        archivedProjects: {
          ...state.archivedProjects,
          projects: newList,
        },
      };

    case types.RESET_SEARCH_RESULTS:
      return {
        ...state,
        searchedProjects: {
          ...state.searchedProjects,
          projects: [],
        },
      };

    case types.SET_PROJECT:
      const { weddingId } = projectChanges || '';
      const updateProject = (projects, project) => {
        if (project.weddingId === weddingId) {
          const changedProject = { ...project };
          return ([...projects, { ...changedProject, ...projectChanges }]);
        }
        return ([...projects, project]);
      };

      const updateProjects = (projects_type) => {
        return projects_type.projects.flat().reduce((projects, project) => {
          return updateProject(projects, project);
        }, []);
      };

      if (projectStatus === 'active') {
        return {
          ...state,
          activeProjects: {
            ...state.activeProjects,
            projects: [...updateProjects(state.activeProjects)],
          },
        };
      }
      if (projectStatus === 'searched') {
        return {
          ...state,
          searchedProjects: {
            ...state.searchedProjects,
            projects: [...updateProjects(state.searchedProjects)],
          },
        };
      }
      return { ...state };

    case types.GET_PROJECT_FEATURES:
      return { ...state };

    case types.GET_PROJECT_FEATURES_SUCCESS:
      {
        const { currentProject } = state;
        const newCurrentProjectInfo = { ...currentProject, features: action.payload };
        return { ...state, currentProject: newCurrentProjectInfo };
      };

    case types.GET_PROJECT_FEATURES_FAIL:
      return { ...state };

    case types.UPDATE_PROJECT_FEATURES:
      return { ...state };

    case types.UPDATE_PROJECT_FEATURES_SUCCESS:
      {
        const { currentProject } = state;
        const newCurrentProjectInfo = { ...currentProject, features: action.payload };
        return { ...state, currentProject: newCurrentProjectInfo };
      };

    case types.UPDATE_PROJECT_FEATURES_FAIL:
      return { ...state };

    case types.WEDDING_PERMISSIONS:
      return { ...state };

    case types.WEDDING_PERMISSIONS_SUCCESS:
      return { ...state, weddingPermission: action.payload };

    default:
      return { ...state };
  };
};
